<template>
	<div class="o-carSingle__formNavigation">
		<div>
			<button
				v-if="showNext"
				type="button"
				class="a-button -primary"
				:disabled="!canProceed || isSubmitting"
				:aria-disabled="(!canProceed || isSubmitting) ? 'true' : 'false'"
				@click="goNext"
			>
				{{ isSubmitting ? 'Bezig...' : nextLabel }}
			</button>
			<button
				v-if="showSubmit"
				type="button"
				class="a-button -primary"
				:disabled="!canProceed || isSubmitting"
				:aria-disabled="(!canProceed || isSubmitting) ? 'true' : 'false'"
				@click="handleSubmit"
			>
				{{ isSubmitting ? 'Bezig...' : submitLabel }}
			</button>
			<div
				v-if="!canProceed && hasErrors"
				class="u-error u-topSpace"
				role="status"
				aria-live="polite"
			>
				<ul v-if="Array.isArray(validationErrors)" class="u-listReset">
					<li v-for="(error, index) in validationErrors" :key="index">
						{{ error }}
					</li>
				</ul>
				<ul v-else-if="typeof validationErrors === 'object' && validationErrors !== null" class="u-listReset">
					<li v-for="(error, key) in validationErrors" :key="key">
						{{ error }}
					</li>
				</ul>
				<p v-else-if="typeof validationErrors === 'string'">
					{{ validationErrors }}
				</p>
			</div>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps( {
	showNext: {
		type: Boolean,
		default: true,
	},
	showSubmit: {
		type: Boolean,
		default: false,
	},
	canProceed: {
		type: Boolean,
		default: true,
	},
	isSubmitting: {
		type: Boolean,
		default: false,
	},
	nextLabel: {
		type: String,
		default: 'Volgende',
	},
	submitLabel: {
		type: String,
		default: 'Direct aanvragen',
	},
	validationErrors: {
		type: [ String, Array, Object ],
		default: null,
	},
} );

const hasErrors = computed( () => {
	if ( ! props.validationErrors ) {
		return false;
	}
	if ( typeof props.validationErrors === 'string' ) {
		return props.validationErrors.trim() !== '';
	}
	if ( Array.isArray( props.validationErrors ) ) {
		return props.validationErrors.length > 0;
	}
	if ( typeof props.validationErrors === 'object' ) {
		return Object.keys( props.validationErrors ).length > 0;
	}
	return false;
} );

const emit = defineEmits( [ 'next', 'submit' ] );

const goNext = () => {
	if ( props.canProceed && ! props.isSubmitting ) {
		emit( 'next' );
	}
};

const handleSubmit = () => {
	if ( props.canProceed && ! props.isSubmitting ) {
		emit( 'submit' );
	}
};
</script>

